import { useQuery } from "@tanstack/react-query";
import { usePageContextQuery } from "@/shared/page-context";
import { getCategoryPlaceData } from "./getCategoryPlaceData";

export const useCategoryPlaceDataQuery = (gpid: string | number | null | undefined) => {
    const { data } = usePageContextQuery();
    const { locale } = data;

    return useQuery({
        queryKey: ["categoryPlaceData", { gpid, culture: locale }],
        enabled: !!gpid,
        queryFn: () => getCategoryPlaceData({ gpid: String(gpid), culture: locale }),
    });
};
